import React from 'react';
import {
    FaUsers, FaChartBar, FaBullseye, FaComments, FaUser, FaFileAlt,
    FaCog, FaEdit, FaTrash, FaEye, FaHeart, FaComment, FaMoon, FaSun,
    FaDoorOpen, FaBars, FaTimes, FaSearch, FaPhone, FaFlag, FaLock,
    FaFootballBall, FaLaptop, FaPizzaSlice, FaPlane, FaBook, FaDumbbell,
    FaUserTie, FaExclamationTriangle, FaMale, FaFemale, FaRocket, FaBolt,
    FaCamera, FaMap, FaUtensils, FaCubes, FaPen, FaRunning, FaYinYang,
    FaWeightHanging, FaFistRaised, FaMobileAlt, FaRobot, FaShieldAlt, FaTools,
    FaBullhorn, FaLayerGroup
} from 'react-icons/fa';
import {
    MdDashboard, MdSportsTennis, MdSportsBasketball, MdSportsCricket,
    MdBackpack, MdLandscape, MdKayaking, MdMenuBook, MdNoteAlt
} from 'react-icons/md';
import { BsClipboardData } from 'react-icons/bs';
import { GiRaceCar, GiCricketBat, GiCupcake, GiBowlOfRice } from 'react-icons/gi';
import {
    IoBicycle, IoFootball, IoBasketball, IoFitness, IoWalk, IoTrophy, IoMedal,
    IoColorPalette, IoGameController, IoMusicalNotes, IoCamera, IoFilm, IoBook, IoTv, IoHeadset, IoBrush,
    IoCar, IoCarSport, IoAirplane, IoBoat, IoBus, IoMap, IoCompass,
    IoHome, IoSettings, IoHeart, IoStar, IoPerson, IoPeople, IoChatbubble, IoNotifications, IoCall, IoMail,
    IoSunny, IoRainy, IoCloudy, IoThunderstorm, IoLeaf, IoFlame, IoWater,
    IoLaptop, IoPhonePortrait, IoDesktop, IoCode, IoWifi, IoBriefcase,
    IoCart, IoCash, IoCard, IoWallet, IoGift, IoPricetag
} from 'react-icons/io5';
import { FaPersonSwimming } from 'react-icons/fa6';

export const renderIcon = (type, size = 16) => {
    // Define color schemes for different categories
    const colorSchemes = {
        // User avatars
        'male': { gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', shadow: 'rgba(102, 126, 234, 0.3)' },
        'female': { gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', shadow: 'rgba(245, 87, 108, 0.3)' },

        // Sports
        'football': { gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)', shadow: 'rgba(56, 239, 125, 0.3)' },
        'cricket': { gradient: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)', shadow: 'rgba(255, 106, 0, 0.3)' },
        'tennis': { gradient: 'linear-gradient(135deg, #f2994a 0%, #f2c94c 100%)', shadow: 'rgba(242, 201, 76, 0.3)' },
        'basketball': { gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', shadow: 'rgba(254, 225, 64, 0.3)' },
        'racecar': { gradient: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)', shadow: 'rgba(48, 207, 208, 0.3)' },

        // Tech
        'laptop': { gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', shadow: 'rgba(102, 126, 234, 0.3)' },
        'mobile': { gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)', shadow: 'rgba(168, 237, 234, 0.3)' },
        'robot': { gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', shadow: 'rgba(0, 242, 254, 0.3)' },
        'rocket': { gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', shadow: 'rgba(250, 112, 154, 0.3)' },
        'bolt': { gradient: 'linear-gradient(135deg, #ffd89b 0%, #19547b 100%)', shadow: 'rgba(255, 216, 155, 0.3)' },

        // Food
        'pizza': { gradient: 'linear-gradient(135deg, #ff9a56 0%, #ff6a88 100%)', shadow: 'rgba(255, 154, 86, 0.3)' },
        'utensils': { gradient: 'linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%)', shadow: 'rgba(251, 194, 235, 0.3)' },
        'rice': { gradient: 'linear-gradient(135deg, #fddb92 0%, #d1fdff 100%)', shadow: 'rgba(253, 219, 146, 0.3)' },
        'cupcake': { gradient: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)', shadow: 'rgba(255, 154, 158, 0.3)' },
        'burger': { gradient: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)', shadow: 'rgba(252, 182, 159, 0.3)' },
        'noodles': { gradient: 'linear-gradient(135deg, #ff6e7f 0%, #bfe9ff 100%)', shadow: 'rgba(255, 110, 127, 0.3)' },

        // Travel
        'plane': { gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', shadow: 'rgba(79, 172, 254, 0.3)' },
        'backpack': { gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)', shadow: 'rgba(67, 233, 123, 0.3)' },
        'camera': { gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', shadow: 'rgba(250, 112, 154, 0.3)' },
        'landscape': { gradient: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)', shadow: 'rgba(48, 207, 208, 0.3)' },
        'map': { gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)', shadow: 'rgba(168, 237, 234, 0.3)' },
        'kayak': { gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', shadow: 'rgba(102, 126, 234, 0.3)' },

        // Books
        'book': { gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', shadow: 'rgba(240, 147, 251, 0.3)' },
        'menubook': { gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', shadow: 'rgba(79, 172, 254, 0.3)' },
        'pen': { gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', shadow: 'rgba(102, 126, 234, 0.3)' },
        'notebook': { gradient: 'linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%)', shadow: 'rgba(251, 194, 235, 0.3)' },

        // Fitness
        'dumbbell': { gradient: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)', shadow: 'rgba(238, 9, 121, 0.3)' },
        'running': { gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)', shadow: 'rgba(56, 239, 125, 0.3)' },
        'yoga': { gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)', shadow: 'rgba(168, 237, 234, 0.3)' },
        'weightlifting': { gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', shadow: 'rgba(250, 112, 154, 0.3)' },
        'gymnastics': { gradient: 'linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%)', shadow: 'rgba(251, 194, 235, 0.3)' },
        'boxing': { gradient: 'linear-gradient(135deg, #ff6e7f 0%, #bfe9ff 100%)', shadow: 'rgba(255, 110, 127, 0.3)' },

        // UI & Navigation
        'dashboard': { gradient: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)', shadow: 'rgba(255, 107, 107, 0.3)' },
        'users_nav': { gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', shadow: 'rgba(79, 172, 254, 0.3)' },
        'groups_nav': { gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)', shadow: 'rgba(67, 233, 123, 0.3)' },
        'chats': { gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', shadow: 'rgba(240, 147, 251, 0.3)' },
        'private_chats': { gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', shadow: 'rgba(240, 147, 251, 0.3)' },
        'posts_nav': { gradient: 'linear-gradient(135deg, #ffd89b 0%, #19547b 100%)', shadow: 'rgba(255, 216, 155, 0.3)' },
        'revenue': { gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', shadow: 'rgba(102, 126, 234, 0.3)' },
        'settings': { gradient: 'linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%)', shadow: 'rgba(137, 247, 254, 0.3)' },
        'activity': { gradient: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)', shadow: 'rgba(246, 211, 101, 0.3)' },
        'shield': { gradient: 'linear-gradient(135deg, #ef4444 0%, #991b1b 100%)', shadow: 'rgba(239, 68, 68, 0.3)' },
        'tool': { gradient: 'linear-gradient(135deg, #2B7FD9 0%, #1e40af 100%)', shadow: 'rgba(43, 127, 217, 0.3)' },
        'megaphone': { gradient: 'linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%)', shadow: 'rgba(255, 107, 107, 0.3)' },
        'categories': { gradient: 'linear-gradient(135deg, #8B5CF6 0%, #6366F1 100%)', shadow: 'rgba(139, 92, 246, 0.3)' },
        'support': { gradient: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)', shadow: 'rgba(245, 158, 11, 0.3)' },

        // Sports & Activities
        'bicycle': { gradient: 'linear-gradient(135deg, #10B981 0%, #059669 100%)', shadow: 'rgba(16, 185, 129, 0.3)' },
        'fitness': { gradient: 'linear-gradient(135deg, #EC4899 0%, #8B5CF6 100%)', shadow: 'rgba(236, 72, 153, 0.3)' },
        'walk': { gradient: 'linear-gradient(135deg, #F59E0B 0%, #EF4444 100%)', shadow: 'rgba(239, 68, 68, 0.3)' },
        'trophy': { gradient: 'linear-gradient(135deg, #FBBF24 0%, #F59E0B 100%)', shadow: 'rgba(245, 158, 11, 0.3)' },
        'medal': { gradient: 'linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)', shadow: 'rgba(59, 130, 246, 0.3)' },
        'swim': { gradient: 'linear-gradient(135deg, #06B6D4 0%, #3B82F6 100%)', shadow: 'rgba(6, 182, 212, 0.3)' },

        // Hobbies & Entertainment
        'color-palette': { gradient: 'linear-gradient(135deg, #EC4899 0%, #8B5CF6 100%)', shadow: 'rgba(139, 92, 246, 0.3)' },
        'game-controller': { gradient: 'linear-gradient(135deg, #3B82F6 0%, #8B5CF6 100%)', shadow: 'rgba(59, 130, 246, 0.3)' },
        'musical-notes': { gradient: 'linear-gradient(135deg, #F43F5E 0%, #FB7185 100%)', shadow: 'rgba(244, 63, 94, 0.3)' },
        'film': { gradient: 'linear-gradient(135deg, #1F2937 0%, #4B5563 100%)', shadow: 'rgba(75, 85, 99, 0.3)' },
        'tv': { gradient: 'linear-gradient(135deg, #4F46E5 0%, #6366F1 100%)', shadow: 'rgba(79, 70, 229, 0.3)' },
        'headset': { gradient: 'linear-gradient(135deg, #6B7280 0%, #9CA3AF 100%)', shadow: 'rgba(107, 114, 128, 0.3)' },
        'brush': { gradient: 'linear-gradient(135deg, #EF4444 0%, #EC4899 100%)', shadow: 'rgba(239, 68, 68, 0.3)' },

        // Travel & Transportation
        'car': { gradient: 'linear-gradient(135deg, #4B5563 0%, #3B82F6 100%)', shadow: 'rgba(59, 130, 246, 0.3)' },
        'car-sport': { gradient: 'linear-gradient(135deg, #EF4444 0%, #111827 100%)', shadow: 'rgba(239, 68, 68, 0.3)' },
        'airplane': { gradient: 'linear-gradient(135deg, #60A5FA 0%, #3B82F6 100%)', shadow: 'rgba(96, 165, 251, 0.3)' },
        'boat': { gradient: 'linear-gradient(135deg, #0EA5E9 0%, #0369A1 100%)', shadow: 'rgba(14, 165, 233, 0.3)' },
        'bus': { gradient: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)', shadow: 'rgba(245, 158, 11, 0.3)' },
        'compass': { gradient: 'linear-gradient(135deg, #6B7280 0%, #1D4ED8 100%)', shadow: 'rgba(29, 78, 216, 0.3)' },

        // Daily Life & Communication
        'home': { gradient: 'linear-gradient(135deg, #F59E0B 0%, #EF4444 100%)', shadow: 'rgba(239, 68, 68, 0.3)' },
        'heart': { gradient: 'linear-gradient(135deg, #EF4444 0%, #F43F5E 100%)', shadow: 'rgba(239, 68, 68, 0.3)' },
        'star': { gradient: 'linear-gradient(135deg, #FBBF24 0%, #D97706 100%)', shadow: 'rgba(251, 191, 36, 0.3)' },
        'person': { gradient: 'linear-gradient(135deg, #3B82F6 0%, #06B6D4 100%)', shadow: 'rgba(59, 130, 246, 0.3)' },
        'people': { gradient: 'linear-gradient(135deg, #10B981 0%, #059669 100%)', shadow: 'rgba(16, 185, 129, 0.3)' },
        'chatbubble': { gradient: 'linear-gradient(135deg, #10B981 0%, #3B82F6 100%)', shadow: 'rgba(16, 185, 129, 0.3)' },
        'notifications': { gradient: 'linear-gradient(135deg, #F59E0B 0%, #FBBF24 100%)', shadow: 'rgba(245, 158, 11, 0.3)' },
        'call': { gradient: 'linear-gradient(135deg, #10B981 0%, #047857 100%)', shadow: 'rgba(16, 185, 129, 0.3)' },
        'mail': { gradient: 'linear-gradient(135deg, #8B5CF6 0%, #4F46E5 100%)', shadow: 'rgba(139, 92, 246, 0.3)' },

        // Weather & Nature
        'sunny': { gradient: 'linear-gradient(135deg, #FBBF24 0%, #F59E0B 100%)', shadow: 'rgba(251, 191, 36, 0.3)' },
        'rainy': { gradient: 'linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)', shadow: 'rgba(59, 130, 246, 0.3)' },
        'cloudy': { gradient: 'linear-gradient(135deg, #9CA3AF 0%, #6B7280 100%)', shadow: 'rgba(156, 163, 175, 0.3)' },
        'thunderstorm': { gradient: 'linear-gradient(135deg, #7C3AED 0%, #FBBF24 100%)', shadow: 'rgba(124, 58, 237, 0.3)' },
        'leaf': { gradient: 'linear-gradient(135deg, #10B981 0%, #059669 100%)', shadow: 'rgba(16, 185, 129, 0.3)' },
        'flame': { gradient: 'linear-gradient(135deg, #EF4444 0%, #F59E0B 100%)', shadow: 'rgba(239, 68, 68, 0.3)' },
        'water': { gradient: 'linear-gradient(135deg, #06B6D4 0%, #3B82F6 100%)', shadow: 'rgba(6, 182, 212, 0.3)' },

        // Tech & Work
        'phone-portrait': { gradient: 'linear-gradient(135deg, #EC4899 0%, #F43F5E 100%)', shadow: 'rgba(236, 72, 153, 0.3)' },
        'desktop': { gradient: 'linear-gradient(135deg, #1E3A8A 0%, #3B82F6 100%)', shadow: 'rgba(30, 58, 138, 0.3)' },
        'code': { gradient: 'linear-gradient(135deg, #059669 0%, #10B981 100%)', shadow: 'rgba(5, 150, 105, 0.3)' },
        'wifi': { gradient: 'linear-gradient(135deg, #3B82F6 0%, #60A5FA 100%)', shadow: 'rgba(59, 130, 246, 0.3)' },
        'briefcase': { gradient: 'linear-gradient(135deg, #78350F 0%, #B45309 100%)', shadow: 'rgba(120, 53, 15, 0.3)' },

        // Shopping & Money
        'cart': { gradient: 'linear-gradient(135deg, #8B5CF6 0%, #EC4899 100%)', shadow: 'rgba(139, 92, 246, 0.3)' },
        'cash': { gradient: 'linear-gradient(135deg, #059669 0%, #10B981 100%)', shadow: 'rgba(5, 150, 105, 0.3)' },
        'card': { gradient: 'linear-gradient(135deg, #111827 0%, #D97706 100%)', shadow: 'rgba(17, 24, 39, 0.3)' },
        'wallet': { gradient: 'linear-gradient(135deg, #D97706 0%, #F59E0B 100%)', shadow: 'rgba(217, 119, 6, 0.3)' },
        'gift': { gradient: 'linear-gradient(135deg, #EC4899 0%, #EF4444 100%)', shadow: 'rgba(236, 72, 153, 0.3)' },
        'pricetag': { gradient: 'linear-gradient(135deg, #F59E0B 0%, #EF4444 100%)', shadow: 'rgba(239, 68, 68, 0.3)' }
    };

    const iconMap = {
        'male': <FaMale size={size} />,
        'female': <FaFemale size={size} />,
        'pizza': <FaPizzaSlice size={size} />,
        'plane': <FaPlane size={size} />,
        'dumbbell': <FaDumbbell size={size} />,
        'racecar': <GiRaceCar size={size} />,
        'cricket': <GiCricketBat size={size} />,
        'tennis': <MdSportsTennis size={size} />,
        'mobile': <FaMobileAlt size={size} />,
        'robot': <FaRobot size={size} />,
        'rocket': <FaRocket size={size} />,
        'bolt': <FaBolt size={size} />,
        'utensils': <FaUtensils size={size} />,
        'rice': <GiBowlOfRice size={size} />,
        'cupcake': <GiCupcake size={size} />,
        'burger': <FaUtensils size={size} />,
        'noodles': <FaUtensils size={size} />,
        'backpack': <MdBackpack size={size} />,
        'landscape': <MdLandscape size={size} />,
        'kayak': <MdKayaking size={size} />,
        'menubook': <MdMenuBook size={size} />,
        'pen': <FaPen size={size} />,
        'notebook': <MdNoteAlt size={size} />,
        'running': <FaRunning size={size} />,
        'yoga': <FaYinYang size={size} />,
        'weightlifting': <FaWeightHanging size={size} />,
        'gymnastics': <FaRunning size={size} />,
        'boxing': <FaFistRaised size={size} />,
        'dashboard': <MdDashboard size={size} />,
        'users_nav': <FaUsers size={size} />,
        'groups_nav': <FaBullseye size={size} />,
        'chats': <FaComments size={size} />,
        'private_chats': <FaUser size={size} />,
        'posts_nav': <FaFileAlt size={size} />,
        'revenue': <FaChartBar size={size} />,
        'activity': <BsClipboardData size={size} />,
        'shield': <FaShieldAlt size={size} />,
        'tool': <FaTools size={size} />,
        'megaphone': <FaBullhorn size={size} />,
        'categories': <FaLayerGroup size={size} />,
        'support': <FaExclamationTriangle size={size} />,

        // Sports & Activities
        'bicycle': <IoBicycle size={size} />,
        'football': <IoFootball size={size} />,
        'basketball': <IoBasketball size={size} />,
        'fitness': <IoFitness size={size} />,
        'walk': <IoWalk size={size} />,
        'trophy': <IoTrophy size={size} />,
        'medal': <IoMedal size={size} />,
        'swim': <FaPersonSwimming size={size} />,

        // Hobbies & Entertainment
        'color-palette': <IoColorPalette size={size} />,
        'game-controller': <IoGameController size={size} />,
        'musical-notes': <IoMusicalNotes size={size} />,
        'camera': <IoCamera size={size} />,
        'film': <IoFilm size={size} />,
        'book': <IoBook size={size} />,
        'tv': <IoTv size={size} />,
        'headset': <IoHeadset size={size} />,
        'brush': <IoBrush size={size} />,

        // Travel & Transportation
        'car': <IoCar size={size} />,
        'car-sport': <IoCarSport size={size} />,
        'airplane': <IoAirplane size={size} />,
        'boat': <IoBoat size={size} />,
        'bus': <IoBus size={size} />,
        'map': <IoMap size={size} />,
        'compass': <IoCompass size={size} />,

        // Daily Life & Communication
        'home': <IoHome size={size} />,
        'settings': <IoSettings size={size} />,
        'heart': <IoHeart size={size} />,
        'star': <IoStar size={size} />,
        'person': <IoPerson size={size} />,
        'people': <IoPeople size={size} />,
        'chatbubble': <IoChatbubble size={size} />,
        'notifications': <IoNotifications size={size} />,
        'call': <IoCall size={size} />,
        'mail': <IoMail size={size} />,

        // Weather & Nature
        'sunny': <IoSunny size={size} />,
        'rainy': <IoRainy size={size} />,
        'cloudy': <IoCloudy size={size} />,
        'thunderstorm': <IoThunderstorm size={size} />,
        'leaf': <IoLeaf size={size} />,
        'flame': <IoFlame size={size} />,
        'water': <IoWater size={size} />,

        // Tech & Work
        'laptop': <IoLaptop size={size} />,
        'phone-portrait': <IoPhonePortrait size={size} />,
        'desktop': <IoDesktop size={size} />,
        'code': <IoCode size={size} />,
        'wifi': <IoWifi size={size} />,
        'briefcase': <IoBriefcase size={size} />,

        // Shopping & Money
        'cart': <IoCart size={size} />,
        'cash': <IoCash size={size} />,
        'card': <IoCard size={size} />,
        'wallet': <IoWallet size={size} />,
        'gift': <IoGift size={size} />,
        'pricetag': <IoPricetag size={size} />
    };

    const icon = iconMap[type] || <FaUser size={size} />;
    const colors = colorSchemes[type] || { gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', shadow: 'rgba(102, 126, 234, 0.3)' };

    return (
        <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: colors.gradient.match(/#[0-9a-fA-F]{6}/) ? colors.gradient.match(/#[0-9a-fA-F]{6}/)[0] : '#667eea',
            background: colors.gradient,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            filter: `drop-shadow(0 1px 2px ${colors.shadow})`
        }}>
            {icon}
        </span>
    );
};
